// extracted by mini-css-extract-plugin
export default {"root":"text_root__OR+la","skeleton":"text_skeleton__u8rDM","copy":"text_copy__ZHwQM"};